import { Button, Drawer, Icon, Image } from "components";
import { PersonDetailsContext } from "pages/PersonDetails";
import { useContext } from "react";
import QRCode from "react-qr-code";
import { ToggleProps } from "types";
type Props = ToggleProps;

export default function QrCodeDrawer({ isOpen, toggle }: Props) {
  const { user, linksRoom, hasAvatarUrl } = useContext(PersonDetailsContext);
  const title = user.careerInfo?.title?.[0].value;
  const hasTitle = !!title;
  const hasLocation = !!user.locationInfo;
  return (
    <Drawer isOpen={isOpen} toggle={toggle}>
      <Drawer.Menu>
        <Drawer.Body className="pb-0">
          {hasAvatarUrl ? (
            <Image
              src={user.avatar?.thumbnailUrl}
              alt={[user.firstName, user.lastName].join(" ")}
              className="block size-[3.125rem] object-cover rounded mx-auto mb-4"
            />
          ) : (
            <div className="flex justify-center items-center size-[3.125rem] rounded mx-auto mb-4 bg-default-theme">
              <Icon
                name="User"
                variant="Bold"
                className="text-[#9A9EB1] size-8"
              />
            </div>
          )}
          <h1 className="block w-full text-center text-lg text-[#181C32] font-semibold mb-1">
            {user.firstName} {user.lastName}
          </h1>
          {hasTitle && (
            <p className="text-sm text-[#9A9EB1] text-center font-medium mb-1">
              {title}
            </p>
          )}
          {hasLocation && (
            <p className="text-xs text-primary text-center font-medium">
              <Icon name="LocationTick" variant="Bold" className="size-4" />{" "}
              {user.locationInfo?.city}, {user.locationInfo?.country}
            </p>
          )}
          <div className="size-fit flex items-center justify-center bg-default-theme rounded p-10 mt-5 mx-auto">
            <QRCode
              value={linksRoom}
              className="size-full max-w-[300px] max-h-[300px] opacity-75 [&>path[fill='#FFFFFF']]:hidden"
            />
          </div>
        </Drawer.Body>
        <Drawer.Footer className="flex items-center justify-center py-8 !border-t-0">
          <Button type="button" variant="text" color="danger" onClick={toggle}>
            Close
          </Button>
        </Drawer.Footer>
      </Drawer.Menu>
    </Drawer>
  );
}
